import { LOCALES_SUPPORTED_CUSTOMER_FACING } from 'constants/locales'
import { orgSelectors } from 'ducks/orgs'
import { getUserType, UserType } from 'opensolar-pageeditor/src/renderer/userUtils'
import { useDataProvider, useLocale } from 'ra-core'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getLocales } from 'resources/documentTemplates/util'
import restClient from 'restClient'
import { NAV_BAR_PREFERRED_COUNTRY, NAV_BAR_PREFERRED_LOCALE } from '../utils'

const API_URL = window.API_ROOT + '/api'

export const useGetProposal = () => {
  const dataProvider = useDataProvider()

  const getLatestProject = useCallback(async () => {
    const result = await dataProvider.getList('projects', {
      pagination: { page: 1, perPage: 1 },
      sort: { field: 'created_date', order: 'DESC' },
      filter: {},
    })
    if (result) {
      return result.data
    }
  }, [])

  const getProposal = useCallback(async (projectId) => {
    try {
      const restClientInstance = restClient(API_URL)
      return await restClientInstance('CUSTOM_GET', 'user_logins', {
        url: `user_logins/?project_ids=${projectId}`,
      })
    } catch (e) {
      console.error(e)
    }
  }, [])

  return { getLatestProject, getProposal }
}

export interface Locale {
  id: string
  name: string
}

const locales = getLocales(LOCALES_SUPPORTED_CUSTOMER_FACING) as Locale[]
export const DEFAULT_COUNTRY = 'US'

export const useUserDefaults = () => {
  const currentLocale = useLocale()
  const org = useSelector(orgSelectors.getOrg)
  const userType: UserType = getUserType(org)

  const getDefaultCountry = (customerLatestProposalCountry: string | null) => {
    let country = localStorage.getItem(NAV_BAR_PREFERRED_COUNTRY)
    if (!country) {
      localStorage.setItem(NAV_BAR_PREFERRED_COUNTRY, DEFAULT_COUNTRY)
      country = DEFAULT_COUNTRY
    }
    if (userType === UserType.ANONYMOUS) return country
    if (userType === UserType.PRO) {
      country = org?.country?.iso2 ?? country
    }
    if (userType === UserType.CUSTOMER) {
      country = customerLatestProposalCountry ?? country // TODO check this should fallback to 'country'
    }
    return country
  }
  const isLocaleSupported = (locale: string) => locales.filter((loc) => loc.id === locale).length > 0 // TODO check this is correct

  const getDefaultLocale = useCallback(() => {
    let locale = localStorage.getItem(NAV_BAR_PREFERRED_LOCALE)
    if (!locale) localStorage.setItem(NAV_BAR_PREFERRED_LOCALE, 'en')
    if (locale && isLocaleSupported(locale)) return locale
    return isLocaleSupported(currentLocale) ? currentLocale : 'en'
  }, [currentLocale])

  return {
    getDefaultCountry,
    getDefaultLocale,
  }
}
